import SpecificationController from "@/services/specificationService";
import Swal from "sweetalert2";

export default {
  name: "SpecificationView",

  data() {
    return {
      items: [],
      total: 0,
      loading: false,

      page: 1,
      perPage: 10,
      perPageOptions: [10, 25, 50, 100],
      totalPages: 1,

      filters: {
        search: "",
        status: "",
      },

      showModal: false,
      isEdit: false,
      saving: false,
      formError: "",

      form: {
        specification_id: null,
        specification_name: "",
        status: 1,
      },

      errors: {
        specification_name: "",
      },

      toast: {
        show: false,
        message: "",
        type: "success",
      },
      toastTimer: null,
    };
  },

  computed: {
    visiblePages() {
      const total = this.totalPages;
      const current = this.page;
      const delta = 2;
      const range = [];

      for (
        let i = Math.max(2, current - delta);
        i <= Math.min(total - 1, current + delta);
        i++
      ) {
        range.push(i);
      }

      if (current - delta > 2) range.unshift("...");
      if (current + delta < total - 1) range.push("...");

      range.unshift(1);
      if (total > 1) range.push(total);

      return range;
    },
  },
  mounted() {
    this.getData();
  },

  methods: {
    async getData() {
      this.loading = true;

      const result = await SpecificationController.getAll({});
      let filtered = result?.data?.data ?? result?.data ?? [];

      // Filter search (by specification_name)
      if (this.filters.search) {
        const q = this.filters.search.toLowerCase();
        filtered = filtered.filter((item) =>
          item.specification_name?.toLowerCase().includes(q),
        );
      }

      // Filter status
      if (this.filters.status !== "") {
        const s = parseInt(this.filters.status);
        filtered = filtered.filter((item) =>
          item.status !== undefined ? item.status == s : true,
        );
      }

      this.total = filtered.length;
      this.totalPages = Math.ceil(this.total / this.perPage) || 1;

      if (this.page > this.totalPages) this.page = this.totalPages;

      const start = (this.page - 1) * this.perPage;
      this.items = filtered.slice(start, start + this.perPage);

      this.loading = false;
    },
    changePerPage() {
      this.page = 1;
      this.getData();
    },

    changePage(p) {
      if (p < 1 || p > this.totalPages) return;
      this.page = p;
      this.getData();
    },
    openModal() {
      this.isEdit = false;
      this.formError = "";
      this.clearErrors();
      this.form = {
        specification_id: null,
        specification_name: "",
        status: 1,
      };
      this.showModal = true;
    },
    openEdit(item) {
      this.isEdit = true;
      this.formError = "";
      this.clearErrors();
      this.form = {
        specification_id: item.specification_id,
        specification_name: item.specification_name,
        status: item.status ?? 1,
      };
      this.showModal = true;
    },
    closeModal() {
      if (this.saving) return;
      this.showModal = false;
      this.formError = "";
      this.clearErrors();
    },

    validateForm() {
      this.clearErrors();
      let valid = true;

      if (!this.form.specification_name?.trim()) {
        this.errors.specification_name = "Nama spesifikasi tidak boleh kosong.";
        valid = false;
      } else if (this.form.specification_name.trim().length > 100) {
        this.errors.specification_name =
          "Nama spesifikasi maksimal 100 karakter.";
        valid = false;
      }

      return valid;
    },

    clearErrors() {
      this.errors = {
        specification_name: "",
      };
    },

    async saveForm() {
      if (!this.validateForm()) return;

      this.saving = true;
      try {
        this.formError = "";

        const payload = {
          specification_name: this.form.specification_name.trim(),
          status: this.form.status,
        };

        let result;

        if (this.isEdit) {
          result = await SpecificationController.update(
            this.form.specification_id,
            payload,
          );
        } else {
          result = await SpecificationController.create(payload);
        }
        if (result.success) {
          this.saving = false;
          this.closeModal();
          this.page = 1;
          this.getData();
          this.showToast(
            this.isEdit
              ? "Spesifikasi perangkat berhasil diperbarui."
              : "Spesifikasi perangkat berhasil ditambahkan.",
            "success",
          );
        } else {
          this.formError = result.message || "Gagal menyimpan data.";
        }
      } catch (err) {
        console.error(err);
        this.formError =
          err.response?.data?.message || err.message || "Gagal menyimpan data.";
      } finally {
        this.saving = false;
      }
    },
    async toggleStatus(item) {
      const newStatus = item.status == 1 ? 0 : 1;
      const action = newStatus === 1 ? "mengaktifkan" : "menonaktifkan";
      const label = newStatus === 1 ? "diaktifkan" : "dinonaktifkan";

      const confirm = await Swal.fire({
        title: "Konfirmasi",
        text: `Yakin ingin ${action} spesifikasi perangkat ini?`,
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Ya",
        cancelButtonText: "Batal",
        confirmButtonColor: "#198754",
      });

      if (!confirm.isConfirmed) return;

      const result = await SpecificationController.updateStatus(
        item.specification_id,
        newStatus,
      );

      if (result.success) {
        this.getData();
        this.showToast(`Spesifikasi perangkat berhasil ${label}.`, "success");
      } else {
        this.showToast(result.message || "Gagal mengubah status.", "danger");
      }
    },
    showToast(message, type = "success") {
      if (this.toastTimer) clearTimeout(this.toastTimer);
      this.toast = { show: true, message, type };
      this.toastTimer = setTimeout(() => {
        this.toast.show = false;
      }, 3000);
    },
  },

  beforeUnmount() {
    if (this.toastTimer) clearTimeout(this.toastTimer);
  },
};
